import { render, staticRenderFns } from "./generate.vue?vue&type=template&id=6b730789"
import script from "./generate.vue?vue&type=script&lang=js"
export * from "./generate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b730789')) {
      api.createRecord('6b730789', component.options)
    } else {
      api.reload('6b730789', component.options)
    }
    module.hot.accept("./generate.vue?vue&type=template&id=6b730789", function () {
      api.rerender('6b730789', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/generate/generate.vue"
export default component.exports